import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilterDesc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFilterDesc"><Path d="M3.5 5.5H18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 12H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 18.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 10.5V19" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 16.5L18.5 19.5L21.5 16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFilterDesc;
